<template>
   <v-row
      justify="center"
      no-gutters
    >
      <v-col
        class="px-5 py-1 white--text"
        cols="12"
      >
        <v-layout align-space-between justify-space-between>

          <div>
            © 2023 National Retail Solutions.
          </div>
          <div v-if="currentRoute === 'nrshome'">
           Altria - Promotions dashboard
          </div>
          <div v-if="currentRoute === 'odareports'">
           Altria - ODA Reports
          </div>

        </v-layout>
      </v-col>
    </v-row>
</template>

<script>
export default {
  computed: {
    currentRoute() {
      return this.$route.name
    }
  }
}
</script>
